"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _gsap = require("gsap");

var _ScrollToPlugin = _interopRequireDefault(require("gsap/umd/ScrollToPlugin"));

var _ramda = require("ramda");

var _excluded = ["tag"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DefaultTag = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    style: style
  }, children);
});
DefaultTag.propTypes = {
  children: _propTypes.node,
  style: (0, _propTypes.shape)({
    overflowX: _propTypes.string,
    overflowY: _propTypes.string
  })
};
var RefWrapper = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var Tag = _ref2.tag,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/_react["default"].createElement(Tag, _extends({
    as: "div"
  }, props, {
    ref: ref
  }));
});
RefWrapper.propTypes = {
  tag: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func, (0, _propTypes.shape)({
    children: _propTypes.node,
    style: (0, _propTypes.shape)({
      overflowX: _propTypes.string,
      overflowY: _propTypes.string
    })
  })])
};
var propTypes = {
  allowScrollX: _propTypes.bool,
  allowScrollY: _propTypes.bool,
  animating: _propTypes.bool,
  children: _propTypes.node,
  duration: _propTypes.number,
  easing: (0, _propTypes.arrayOf)(_propTypes.string),
  scrollByPercentage: _propTypes.bool,
  scrollX: _propTypes.number,
  scrollY: _propTypes.number,
  tag: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func, (0, _propTypes.shape)({
    children: _propTypes.node,
    style: (0, _propTypes.shape)({
      overflowX: _propTypes.string,
      overflowY: _propTypes.string
    })
  })]),
  updateAnimation: _propTypes.func
};
var defaultProps = {
  allowScrollX: false,
  allowScrollY: true,
  animating: false,
  duration: 0.25,
  easing: ["Power4", "easeOut"],
  scrollByPercentage: false,
  scrollX: 0,
  scrollY: 0,
  tag: DefaultTag
};

var scrollToAnimation = function scrollToAnimation(_ref3) {
  var scrollRef = _ref3.scrollRef,
      duration = _ref3.duration,
      easing = _ref3.easing,
      updateAnimation = _ref3.updateAnimation,
      scrollByPercentage = _ref3.scrollByPercentage,
      scrollX = _ref3.scrollX,
      scrollY = _ref3.scrollY;

  _gsap.TweenLite.to(scrollRef.current, duration, {
    ease: easing.join("."),
    onComplete: function onComplete() {
      if ((0, _ramda.is)(Function, updateAnimation)) {
        updateAnimation(false);
      }
    },
    scrollTo: {
      x: scrollByPercentage ? (scrollRef.current.scrollWidth - scrollRef.current.clientWidth) * scrollX : scrollX,
      y: scrollByPercentage ? (scrollRef.current.scrollHeight - scrollRef.current.clientHeight) * scrollY : scrollY
    }
  });
};

var ScrollTo = function ScrollTo(_ref4) {
  var allowScrollX = _ref4.allowScrollX,
      allowScrollY = _ref4.allowScrollY,
      animating = _ref4.animating,
      children = _ref4.children,
      duration = _ref4.duration,
      easing = _ref4.easing,
      scrollByPercentage = _ref4.scrollByPercentage,
      scrollX = _ref4.scrollX,
      scrollY = _ref4.scrollY,
      tag = _ref4.tag,
      updateAnimation = _ref4.updateAnimation;
  var scrollRef = (0, _react.useRef)();
  var prevAnimatingRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    prevAnimatingRef.current = animating;
  });
  (0, _react.useEffect)(function () {
    if (animating || animating !== prevAnimatingRef.current) {
      scrollToAnimation({
        duration: duration,
        easing: easing,
        scrollByPercentage: scrollByPercentage,
        scrollRef: scrollRef,
        scrollX: scrollX,
        scrollY: scrollY,
        updateAnimation: updateAnimation
      });
    }
  });
  return /*#__PURE__*/_react["default"].createElement(RefWrapper, {
    ref: scrollRef,
    style: {
      overflowX: allowScrollX ? "auto" : "visible",
      overflowY: allowScrollY ? "auto" : "visible"
    },
    tag: tag
  }, children);
};

ScrollTo.propTypes = propTypes;
ScrollTo.defaultProps = defaultProps;
var _default = ScrollTo;
exports["default"] = _default;